<template>
  <v-row justify="center">
    <v-dialog
        v-model="inputDialog"
        :persistent="true"
        width="50%"
        height="100%"
        class="modalDialog"
        no-click-animation
      >
      <v-card class="cardWrap">
        <CardTitle :title="page_title"/>
          <v-container>
            <v-col cols="12" md="12">
              <v-row>
                <v-form
                    ref="form"
                    lazy-validation
                >
                  <v-row justify="start">
                    <div class="cardWrap__fromArea__title">氏名</div>
                    <v-text-field :value="name" disabled/>
                  </v-row>
                  <v-row justify="start">
                    <div class="cardWrap__fromArea__title">ゴルフ場</div>
                      <v-select
                          :items="golf_courses"
                          item-value="golf_code"
                          item-text="golf_name"
                          :disabled="changeModeStatus"
                          v-model="from_set_data.golf_courses_val"
                          autofocus
                      />
                  </v-row>
                  <v-row justify="start">
                    <div class="cardWrap__fromArea__title"></div>
                    <v-radio-group
                        v-model="from_set_data.member_class"
                        row
                        class="customClass">
                        <v-radio
                            v-for="item in reverseItems"
                            :key="item.id"
                            :label="item.code_name"
                            :value="item.code"
                        />
                    </v-radio-group>
                  </v-row>
                </v-form>
              </v-row>
            </v-col>
          </v-container>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-4" text @click="CloseModal">キャンセル</v-btn>
            <v-btn color="blue  darken-4" text v-if="addModeStatus" @click="validateCheck">登録</v-btn>
            <v-btn color="green darken-4" text v-if="changeModeStatus" @click="validateCheck">変更</v-btn>
        </v-card-actions>
        <AddOverlay
            page-name="会員区分"
            @processing="addMemberClass"
            @cancel="addOverlay = !addOverlay"
            :dblclickStop="processing"
            :process-result="process"
            :OverlaySwitch="addOverlay"
            />
        <ChangeOverlay
            page-name="会員区分"
            @processing="updateMemberClass"
            @cancel="changeOverlay = !changeOverlay"
            :dblclickStop="processing"
            :process-result="process"
            :OverlaySwitch="changeOverlay"
            />
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';
// import { GET_GOLFCOURSE } from '@/constants/member_card';
import AddOverlay from '@/views/Master/page/overlay/AddOverlay';
import ChangeOverlay from '@/views/Master/page/overlay/ChangeOverlay';
import { InputPageMixin } from '@/views/Member/InputPageMixin.js';
import {
    REGISTER_MEMBER_CLASS,
    CHANGE_MEMBER_CLASS
} from '@/constants/member_class';
import { GET_CODE_LIST } from '@/constants/codelist';

export default {
    components: {
        CardTitle,
        AddOverlay,
        ChangeOverlay
    },
    mixins: [InputPageMixin],
    props: [
        'name',
        'MemNo',
        'editInfo',
        'golf_courses',
        'golf_code'
    ],
    data () {
        return {
            // 会員番号
            page_title: '会員区分登録',
            from_set_data: {
                id: '',
                golf_courses_val: '',
                member_class: '2'
            },
            headers: [
                { text: 'ゴルフ場', align: 'center', value: 'golf_name', sortable: false },
                { text: '', align: 'center', value: 'member_class', sortable: false },
                { text: '', align: 'center', value: 'Btn', sortable: false, class: 'customBtn' }
            ],
            items: []
        };
    },
    watch: {
        modeStatus () {
            if (this.modeStatus === 'addMode') {
                this.$set(this.from_set_data, 'golf_courses_val', this.golf_code);
                this.page_title = '会員区分登録';
            } else if (this.modeStatus === 'changeMode') {
                this.page_title = '会員区分変更';
            }
        },
        editInfo () {
            this.from_set_data.id = this.editInfo.id;
            this.from_set_data.golf_courses_val = this.editInfo.golf_code;
            this.from_set_data.member_class = this.editInfo.member_class;
        }
    },
    created () {
        this.getCodeList();
    },
    computed: {
        reverseItems () {
            return this.items.slice().reverse();
        }
    },
    methods: {
        addMemberClass () {
            this.$apollo.mutate({
                mutation: REGISTER_MEMBER_CLASS,
                variables: {
                    member_no: this.MemNo,
                    golf_group_code: this.golf_groups_val,
                    golf_code: this.from_set_data.golf_courses_val,
                    member_class: this.from_set_data.member_class
                }
            }).then(res => {
                this.process.result = res.data.registerMemberClass.result;
                if (this.process.result === 1) {
                    this.addOverlay = !this.addOverlay;
                    this.CloseModal();
                } else if (this.process.result === 0) {
                    this.process.resultText = res.data.registerMemberClass.errorMessage;
                }
            }).catch(error => {
                this.process.result = 0;
                this.process.resultText = this.$t('result.error.regist');
                this.error = error;
                this.processing = false;
            });
        },
        updateMemberClass () {
            this.$apollo.mutate({
                mutation: CHANGE_MEMBER_CLASS,
                variables: {
                    id: this.from_set_data.id,
                    member_class: this.from_set_data.member_class
                }
            })
                .then(res => {
                    this.process.result = res.data.changeMemberClass.result;
                    if (this.process.result === 1) {
                        this.changeOverlay = !this.changeOverlay;
                        this.CloseModal();
                    } else if (this.process.result === 0) {
                        this.process.resultText = res.data.changeMemberClass.errorMessage;
                    }
                    this.processing = false;
                }).catch(error => {
                    this.process.result = 0;
                    this.process.resultText = this.$t('result.error.change');
                    this.error = error;
                    this.processing = false;
                });
        },
        getCodeList () {
            this.$apollo.query({
                query: GET_CODE_LIST,
                fetchPolicy: 'no-cache',
                variables: {
                    code_key: 'display_member_class',
                    default_display: 0
                }
            }).then(res => {
                const data = res.data.GetCodeList.CodeList;
                this.items.push(...data);
            });
        }
    }
};
</script>

<style scoped>
.cardWrap{
    margin: 0;
    padding: 20px 15px 15px;
}

.v-card{
    box-shadow: none;
}

.customClass ::v-deep .v-select{
    width:200px;
}
.customClass ::v-deep .v-input--selection-controls__input{
    width:16px;
}

.customClass ::v-deep .v-input--radio-group__input{
    flex-wrap: nowrap;
    max-width: 370px;
}

.customClass ::v-deep i{
    font-size: 15px;
}

.v-text-field{
    width: 300px;
}

.v-radio{
    margin-right:5px;
}

.customClass ::v-deep label{
    font-size: 15px;
}

.customClass ::v-deep .customBtn{
    display: inline-block;
    flex-direction: row;
}
</style>
